<template>
    <div :class="[{ 'active': props.isActive }]" class="list-item">
        <div v-if="nameInput" class="form-group">
            <input v-if="props.place.name" v-model="props.place.name" type="text" class="form-control form-control-sm">
            <small v-if="props.place.address" class="text-monospace">{{ props.place.address }}</small>
        </div>
        <div v-else>
            <strong v-if="props.place?.name">
                {{ props.place.name }}
            </strong><br>
            <small v-if="props.place.address">{{ props.place.address }}</small>
        </div>
    </div>
</template>

<script setup>
import { ref, watchEffect, onMounted } from 'vue'

const props = defineProps({
    place: Object,
    isActive: {
        type: Boolean,
        default: false,
    }
})

const nameInput = ref(false)

onMounted(() => {
    if (props.place?.name == 'unnamed') {
        nameInput.value = true
    }
})

watchEffect(() => {
    if (props.place?.name === 'unnamed') {
        nameInput.value = true
    }
})
</script>

<style scoped>
.list-item {
    color: var(--link-color);
    text-decoration: none;
    text-transform: uppercase;
    font-family: 'RobotoMono-Regular', 'Roboto';
    cursor: pointer;
}

.list-item:hover {
    color: var(--link-color-hover);
}

.list-item.active {
    color: var(--link-color-hover);
}
</style>
